/**
 * Store item to localStorage with an expiry.
 *
 * Useful future offset values:
 *   oneHour = 3.6e6; // ie, 60 * 60 * 1000
 *   oneDay = 86.4e6; // ie, 24 * 60 * 60 * 1000
 *   oneWeek => 604.8e6; // ie, 7 * 24 * 60 * 60 * 1000
 *
 * @param {string} key the string name of the variable to store.
 * @param {any} value the value to store.
 * @param {int} ttl a timestamp indicating when the item expires.
 */
const setWithExpiry = (key, value, ttl) => {
  const now = new Date().getTime();
  const item = {
    value: value,
    expiry: now + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
};

// Get the query parameters from the current URL
const params = new URLSearchParams(window.location.search);

// Create an object to store utm for later.
const utmParams = {};

for (const [key, value] of params.entries()) {
  // check for utm_ or appeal parameters
  if (key.startsWith('utm_') || key.startsWith('appeal')) {
    utmParams[key] = value;
    // console.log(`${key}: ${value}`);
    const oneWeek = 604.8e6;
    setWithExpiry("Emory.commerce.order."+key, value, oneWeek);
    // console.debug("Emory.commerce.order."+key, value);
    // window.dataLayer = window.dataLayer || [];
    // window.dataLayer.push({ key: value });
  }
}